import { fetchZoneDescription } from './zoneHelpers';
import {
  EMapEntitiesActions,
  fetchZoneDescriptionSet,
  ZONES_WITH_INFO
} from './mapEntitiesConstants';
import { randomStr } from 'other/helpers';

import {
  EMarkerCategory,
  TLayerPointLocation,
  TZoneInfo,
  TZoneInfoGroup
} from 'types';
import { TState } from '../../appStateModel';

/**
 *
 */
export function fetchZoneDescriptionAction(location: TLayerPointLocation) {
  return (dispatch, getState) => {
    const { mapOptions } = getState() as TState;

    const hasInfoZone = mapOptions.mapAreas.zones.some((z) =>
      ZONES_WITH_INFO.includes(z)
    );

    if (!hasInfoZone) return;

    dispatch(
      fetchZoneDescriptionSet.request({
        [EMarkerCategory.ZONE_INFO]: []
      })
    );

    fetchZoneDescription(location)
      .then((items: TZoneInfo[]) => {
        if (items.length === 0) return;

        const arr = items.filter((item: TZoneInfo) =>
          mapOptions.mapAreas.zones.includes(item.name)
        );

        if (arr.length === 0) return;

        const group = {
          id: randomStr(),
          items: arr,
          lat: location.latitude,
          lng: location.longitude
        };

        dispatch(
          fetchZoneDescriptionSet.success({
            [EMarkerCategory.ZONE_INFO]: [group]
          })
        );
      })
      .catch((e) => dispatch(fetchZoneDescriptionSet.error(e)));
  };
}

/**
 *
 */
export function closeZoneInfoAction() {
  return {
    type: EMapEntitiesActions.CLOSE_ZONE_INFO,
    payload: { zoneInfo: [] }
  };
}

/**
 *
 */
export function checkInfosAction(clearAll?: boolean) {
  return (dispatch, getState) => {
    const { mapEntities, mapOptions } = getState() as TState;

    if (clearAll) {
      return dispatch({
        type: EMapEntitiesActions.CHECK_ZONE_INFO,
        payload: { zoneInfo: [] }
      });
    }

    const update = mapEntities.zoneInfo
      .map((info: TZoneInfoGroup) => {
        const items = info.items.filter((item: TZoneInfo) =>
          mapOptions.mapAreas.zones.includes(item.name)
        );
        return { ...info, items };
      })
      .filter((info: TZoneInfoGroup) => info.items.length > 0);

    dispatch({
      type: EMapEntitiesActions.CHECK_ZONE_INFO,
      payload: { zoneInfo: update }
    });
  };
}

/**
 *
 */
function toggleItems(items: TZoneInfo[], current: TZoneInfo[]): TZoneInfo[] {
  let arr = [...current];

  items.forEach((item: TZoneInfo) => {
    const includes = arr.find((a: TZoneInfo) => a.id === item.id);

    if (includes) {
      arr = arr.filter((a: TZoneInfo) => a.id !== item.id);
    } else {
      arr.push(item);
    }
  });

  return arr;
}
